import { CARTLINE_QUANTITIES_COOKIE_NAME, parseCartQuantities } from '@digital-retail/store-manager';
import CookieStorage from '../CookieStorage';

export const CARTLINE_QTY_HEADER = 'x-cartline-quantities';

export const updateCartQtyLimits = ({ response, isTottusSA }) => {
  if (!isTottusSA || response.statusCode !== 200) {
    return;
  }

  const { headers = new Headers() } = response;
  const qtyLimits = headers?.get(CARTLINE_QTY_HEADER) ?? '';
  const map = parseCartQuantities(qtyLimits);
  const obj = Object.fromEntries(map);
  localStorage.setItem(CARTLINE_QTY_HEADER, JSON.stringify(obj));
};

export const getQtyMapFromStorage = (useLocalStorageForQtyLimits) => {
  if (useLocalStorageForQtyLimits) {
    const item = localStorage.getItem(CARTLINE_QTY_HEADER) ?? '{}';
    const json = JSON.parse(item);

    return new Map(Object.entries(json));
  }

  return parseCartQuantities(CookieStorage.getCookie(CARTLINE_QUANTITIES_COOKIE_NAME));
};
